import styled from 'styled-components';

export const Card = styled.div`
  width: 100%;
  padding: 32px 40px;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 10px 26px rgb(0 0 0 / 5%);
  margin-bottom: 24px;
`;

export const PageTitle = styled.h1`
  color: #2e3958;
  font-size: 20px;
  font-weight: 600;
  margin: 0 0 24px;
`;

export const CardContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 32px;

  @media (max-width: 768px) {
    align-items: flex-start;
    flex-direction: column;
  }
`;

export const SectionTitle = styled.h2`
  color: #252b37;
  font-size: 16px;
  font-weight: 700;
  margin: 0 0 18px;
`;

export const DataGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(140px, 1fr));
  gap: 28px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 14px;
  }
`;

export const DataItem = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
`;

export const Label = styled.span`
  color: #252b37;
  font-size: 14px;
  font-weight: 700;
  margin-bottom: 8px;
`;

export const Value = styled.span`
  color: #4b5563;
  font-size: 14px;
  font-weight: 400;
  overflow-wrap: anywhere;
`;

export const RequestEyebrow = styled.span`
  color: #252b37;
  display: block;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 16px;
  text-transform: uppercase;
`;

export const RequestTitle = styled.h2`
  color: #252b37;
  font-size: 18px;
  font-weight: 700;
  margin: 0 0 4px;
`;

export const RequestDescription = styled.p`
  color: #4b5563;
  font-size: 14px;
  line-height: 1.4;
  margin: 0;
  max-width: 560px;
`;
